//#region src/fetch/use-base-fetch/types.ts
var e = /* @__PURE__ */ function(e) {
	return e.get = "get", e.delete = "delete", e.head = "head", e.options = "options", e.post = "post", e.put = "put", e.patch = "patch", e.postForm = "postForm", e;
}({}), t = [
	"get",
	"delete",
	"head",
	"options"
];
//#endregion
export { e as RequestMethodsEnum, t as methodsWithoutBody };
